import * as React from 'react';

import {Button} from 'shells/button/button';
import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Illustration} from 'shells/illustrations/illustration';

type Props = {
    onPrimaryCtaClick: () => void;
};

export function EmptyState(props: Props) {
    return (
        <EmptyStateLarge
            title='Welcome to your drip sequences page'
            subtitle='Drip sequences and the messages they contain will appear here'
            detailTextBullets={[
                'Create a drip sequence to automatically send a series of messages over time',
                'Use automated start triggers to start sending your drip sequences at exactly the right moment',
                'Set up a goal for your drip sequence and automate a next step in Nutshell when a recipient meets the goal',
            ]}
            cta={
                <Button variant='primary' size='big' onClick={props.onPrimaryCtaClick}>
                    Create drip sequence
                </Button>
            }
            icon={
                <div style={{width: 240, paddingRight: 24}}>
                    <Illustration src='drip-sequence-doodle' width='100%' height='100%' />
                </div>
            }
        />
    );
}
